import React, { useState } from "react";
import { Box, TextField, Button, Grid } from "@mui/material";
import AsyncAutocomplete from "../../components/AsyncAutoComplete";
import AsyncAutoCompleteMultiSelect from "../../components/AsyncAutoCompleteMultiSelect";
import { useSnackbar } from "../../Context/Contexts";
import { Option } from "../../Types/CommonTypes";
import { useTranslation } from "react-i18next";
const GenerateCode = (description: string): string => {
    // Remove spaces, trim, and normalize the description to generate a code
    const cleaned = description
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();

    const significantLoss = description.length - cleaned.length > 3;
    const tooShort = cleaned.length < 5;

    if (significantLoss && tooShort) {
        return crypto.randomUUID().replace(/-/g, "").slice(0, 10);
    }
    return cleaned;
};

const ColorSizeLengthInput: React.FC<{
    label: string;
    options: Option[];
    setOptions: React.Dispatch<React.SetStateAction<Option[]>>;
}> = ({ label, options, setOptions }) => {
    const [inputValue, setInputValue] = useState("");
    const { showSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const handleAddOption = () => {
        if (inputValue.trim() === "") {
            showSnackbar(t("dialog.enterValidDescription"), "error");
            return;
        }

        const newOption: Option = {
            value: GenerateCode(inputValue),
            description: inputValue.trim(),
        };



        // Check if the option already exists
        if (options.some((option) => option.value === newOption.value)) {
            showSnackbar(t("dialog.optionExists"), "error");
            return;
        }

        setOptions((prev) => [...prev, newOption]);
        setInputValue(""); // Clear the input
    };

    return (
        <Box sx={{ marginBottom: 2 }}>
            <TextField
                label={`${t("common.add")} ${label}`}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                fullWidth
                inputProps={{ maxLength: 100 }}
                sx={{ marginBottom: 1 }}
            />
            <Button variant="contained" onClick={handleAddOption}>
                {`${t("common.add")} ${label}`}
            </Button>
        </Box>
    );
};

export default ColorSizeLengthInput;
